export class ErrorWithResourceKey extends Error {
    constructor(public name: string, public message: string, public resourceKey?: string) {
        super(message);

        // Fix prototype chain (will ensure instanceof is working properly)
        Object.setPrototypeOf(this, new.target.prototype);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/errorWithResourceKey.ts